import Api from '../Api';

import { url } from './config';
import { TravelAgentType } from './types';

const api = new Api<TravelAgentType>(url);

export default api;
